<ng-container *ngIf="activationItemSummaries?.length || instantActivationItemSummaries?.length">
  <!--Instant Billed Items-->
  <ng-container *ngIf="instantActivationItemSummaries?.length">
    <div *ngFor="let item of instantActivationItemSummaries">
      <app-order-form-custom-price-form [item]="item"></app-order-form-custom-price-form>
    </div>
  </ng-container>

  <!--Non-Instant Billed Items-->
  <ng-container *ngIf="activationItemSummaries?.length">
    <div *ngFor="let item of activationItemSummaries">
      <app-order-form-custom-price-form [item]="item"></app-order-form-custom-price-form>
    </div>
  </ng-container>
</ng-container>
